import { socialIcons } from "reference-data/socialIcons"

export const setIcon = (name: string) => socialIcons.get(name)
